import type { EventDeliveryConfig, EventDraftInput, EventOperationsConfig, EventServiceMode } from './types'

export type EventTemplateId = 'counter' | 'table-service' | 'hybrid'

export interface EventTemplate {
  id: EventTemplateId
  label: string
  description: string
  operations: EventOperationsConfig
  delivery: EventDeliveryConfig
  enabledModules: string[]
}

const baseModules = ['dashboard', 'orders', 'catalog-builder', 'cash-register', 'production']

export const eventTemplates: EventTemplate[] = [
  {
    id: 'counter',
    label: 'Festa con cassa',
    description: 'Ordini gestiti dalla cassa con ritiro al banco.',
    operations: { serviceModes: ['counter'], defaultServiceMode: 'counter', tableCount: 1, requireCustomerName: false, requireTableReference: false, allowQuantityEdit: true },
    delivery: { allowTogether: true, allowByDepartment: false, defaultMode: 'together' },
    enabledModules: baseModules,
  },
  {
    id: 'table-service',
    label: 'Festa con tavoli',
    description: 'Ordini associati al tavolo e consegna configurabile.',
    operations: { serviceModes: ['table'], defaultServiceMode: 'table', tableCount: 30, requireCustomerName: false, requireTableReference: true, allowQuantityEdit: true },
    delivery: { allowTogether: true, allowByDepartment: true, defaultMode: 'together' },
    enabledModules: baseModules,
  },
  {
    id: 'hybrid',
    label: 'Evento ibrido',
    description: 'Banco, tavoli e asporto nello stesso evento.',
    operations: { serviceModes: ['counter', 'table', 'takeaway'], defaultServiceMode: 'counter', tableCount: 30, requireCustomerName: true, requireTableReference: false, allowQuantityEdit: true },
    delivery: { allowTogether: true, allowByDepartment: true, defaultMode: 'together' },
    enabledModules: [...baseModules, 'payments'],
  },
]

export function getEventTemplate(id: EventTemplateId): EventTemplate {
  const template = eventTemplates.find((item) => item.id === id)
  if (!template) throw new Error(`Template evento non supportato: ${id}`)
  return template
}

export function eventDraftFromTemplate(input: {
  templateId: EventTemplateId
  name: string
  startsAt?: string | null
  endsAt?: string | null
  primaryColor?: string
  accentColor?: string
  tableCount?: number
}): EventDraftInput {
  const template = getEventTemplate(input.templateId)
  const serviceModes = [...template.operations.serviceModes] as EventServiceMode[]
  const operations: EventOperationsConfig = {
    ...template.operations,
    serviceModes,
    tableCount: input.tableCount ? Math.max(1, Math.min(300, input.tableCount)) : template.operations.tableCount,
  }
  return {
    name: input.name.trim(),
    startsAt: input.startsAt ?? null,
    endsAt: input.endsAt ?? null,
    branding: {
      displayName: input.name.trim(),
      primaryColor: input.primaryColor || '#111827',
      accentColor: input.accentColor || '#f59e0b',
    },
    config: {
      operations,
      delivery: { ...template.delivery },
      enabledModules: [...template.enabledModules],
      template: { id: template.id, version: 1 },
    },
  }
}
